import { render, staticRenderFns } from "./land-arch.vue?vue&type=template&id=0643ebfa&"
import script from "./land-arch.vue?vue&type=script&lang=js&"
export * from "./land-arch.vue?vue&type=script&lang=js&"
import style0 from "./land-arch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports